import { SET_LOADING } from './types';

export const mutations = {
    [SET_LOADING]: (state, payload) => {
        state.loading = payload;
    }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js